






































































import mixins from 'vue-typed-mixins'
import I18N from '@/components/I18N.ts'
import * as UI from '@/helpers/UI.ts'

import axios from 'axios'

interface Data {
  root: Root | null
  lexemes: Lexeme[] | null
}

export default mixins(I18N).extend({
  components: {
  },
  data (): Data {
    return {
      root: null,
      lexemes: []
    }
  },
  watch: {
    '$route.params': {
      handler (): void {
        this.load()
        let title = this.$route.params.radicals
        switch (this.$route.params.variant) {
          case '1': title += ' ¹'; break
          case '2': title += ' ²'; break
          case '3': title += ' ³'; break
          case '4': title += ' ⁴'; break
          case '5': title += ' ⁵'; break
        }
        this.$store.dispatch('setTitle', title)
      },
      immediate: true
    }
  },
  computed: {
    rootClass (this: any): string {
      if (!this.root) return ''
      let out = ''
      if (this.root.type !== 'irregular') {
        let radicalCount = this.root.radicals.split('-').length
        out += radicalCount === 4 ? this.__('root.quad') : this.__('root.tri')
      }
      out += ' ' + this.__(`root.type.${this.root.type}`)
      return out
    }
  },
  methods: {
    // get root and lexemes
    load (): void {
      let path = this.$route.params.variant ? `${this.$route.params.radicals}/${this.$route.params.variant}` : `${this.$route.params.radicals}`
      axios.get(`${process.env.VUE_APP_API_URL}/roots/${path}`)
        .then(response => {
          this.root = response.data
        })
        .catch(error => {
          this.$store.dispatch('addError', error)
          this.root = {} as Root
        })
      axios.get(`${process.env.VUE_APP_API_URL}/roots/lexemes/${path}`)
        .then(response => {
          this.lexemes = response.data
        })
        .catch(error => {
          this.$store.dispatch('addError', error)
          this.lexemes = []
        })
    },
    // Making helper functions available to template
    derivedForm: UI.derivedForm
  },
  mounted (): void {
  }
})
